import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { CaseLookupComponent } from 'src/app/search/case-lookup.component';
import { AgendaLookupComponent } from 'src/app/agenda/agenda-lookup.component';
import { MinutesLookupComponent } from 'src/app/minutes/minutes-lookup.component';
import {FormsModule} from "@angular/forms";
import { PublicService } from './services/public.service';
import { HttpClientModule, HTTP_INTERCEPTORS  } from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CaseLookupComponent,
    AgendaLookupComponent,
    MinutesLookupComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
  ],
  providers: [
    PublicService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
